module.exports = __webpack_public_path__ + "img/deepseek_icon.28eaa6da.svg";